import { render } from "./SaleDetailView.vue?vue&type=template&id=4fa6810e"
import script from "./SaleDetailView.vue?vue&type=script&lang=js"
export * from "./SaleDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__